export default {
  namespaced: true,
  state: {},
  mutations: {},
  //处理异步
  actions: {},
  //提取对state的公共操作
  getters: {},
};
